import { render, staticRenderFns } from "./RelationDate.vue?vue&type=template&id=5e107d09"
import script from "./RelationDate.vue?vue&type=script&lang=ts"
export * from "./RelationDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports